// Mock data for Meskim Kimya Ltd.Şti. website

export const companyInfo = {
  name: "Meskim Gıda İthalat İhracat Sanayi ve Ticaret Limited Şirketi",
  shortName: "Meskim",
  tagline: "Gıda ve Kimya Sektöründe Güvenilir Çözüm Ortağınız",
  description: "Türkiye'nin ilk ve tek glukonik asit ve glukono delta lakton üreticisi olarak, gıda ve kimya sektörlerine yüksek kaliteli ürünler sunuyoruz.",
  address: "Evciosb mahallesi O.S.B. 8. Cadde City Group Enerji A.Ş. No:8 Akdeniz/Mersin",
  phone: "+90 544 518 18 00",
  email: "info@meskim.com.tr",
  workingHours: "Pazartesi - Cuma: 08:00 - 18:00",
  logo: "/images/logo.jpg"
};

export const products = [
  {
    id: 1,
    name: "Glukonik Asit %50",
    description: "Sıvı formda %50 konsantrasyonunda glukonik asit üretimi yapıyoruz. Gıda, ilaç ve endüstriyel uygulamalarda yaygın olarak kullanılan yüksek saflıkta ürün.",
    specifications: "Sıvı Form - %50 Konsantrasyon",
    applications: [
      "Gıda katkı maddesi",
      "pH düzenleyici",
      "İlaç sanayii",
      "Metal yüzey temizliği",
      "Beton katkı maddesi"
    ],
    image: "/images/gluconic-acid.jpg"
  },
  {
    id: 2,
    name: "Glukonat Tuzları",
    description: "Çeşitli glukonat tuzları üretimi: Sodyum Glukonat, Potasyum Glukonat, Kalsiyum Glukonat ve Bakır Glukonat. Her biri farklı endüstriyel ve farmasötik uygulamalar için özel olarak üretilmektedir.",
    specifications: "Toz Form - Çeşitli Saflık Dereceleri",
    applications: [
      "Sodyum Glukonat - Beton katkı",
      "Potasyum Glukonat - Gıda takviyesi",
      "Kalsiyum Glukonat - İlaç üretimi",
      "Bakır Glukonat - Mineral takviye",
      "Su arıtma sistemleri"
    ],
    image: "/images/sodium-gluconate.jpg"
  },
  {
    id: 3,
    name: "Glukono Delta Lakton (GDL)",
    description: "Glukono Delta Lakton, gıda endüstrisinde asitlik düzenleyici ve pıhtılaştırıcı olarak kullanılan yüksek kaliteli kimyasal üründür. Özellikle süt ürünleri ve et ürünleri işlemede tercih edilir.",
    specifications: "Toz Form - Yüksek Saflık",
    applications: [
      "Peynir üretimi",
      "Et ürünleri işleme",
      "Fırıncılık ürünleri",
      "Asitlik düzenleyici",
      "Tofu üretimi"
    ],
    image: "/images/gdl-product.jpg"
  }
];

export const services = [
  {
    id: 1,
    title: "Üretim ve İmalat",
    description: "Modern tesislerimizde uluslararası standartlarda üretim yapıyoruz.",
    icon: "factory"
  },
  {
    id: 2,
    title: "Kalite Kontrol",
    description: "Her üretim aşamasında titiz kalite kontrol süreçleri uyguluyoruz.",
    icon: "check-circle"
  },
  {
    id: 3,
    title: "Lojistik ve Dağıtım",
    description: "Türkiye ve dünya genelinde güvenli ve hızlı teslimat hizmeti.",
    icon: "truck"
  },
  {
    id: 4,
    title: "Teknik Destek",
    description: "Uzman ekibimizle 7/24 teknik destek ve danışmanlık hizmeti sunuyoruz.",
    icon: "headphones"
  }
];

export const stats = [
  { label: "Yıllık Deneyim", value: "25+" },
  { label: "Üretim Kapasitesi (ton/yıl)", value: "7000+" },
  { label: "Müşteri Memnuniyeti", value: "%100" },
  { label: "İhracat Ülkesi", value: "15+" }
];

export const certifications = [
  "ISO 9001:2015",
  "ISO 22000",
  "HACCP",
  "GMP"
];